
/*
    eslint-disable
    prefer-arrow-callback,func-names,array-callback-return,no-console,no-unused-vars,no-undef,
    no-nested-ternary,one-var-declaration-per-line,no-unused-expressions,max-len,no-continue,no-loop-func,
    object-property-newline
*/

import { mapMutations, mapState } from "vuex";
import iteratorsCommons from "@/components/UserInterfaces/renderer/mixins/iterators-commons";
import BodyRenderer from "@/components/UserInterfaces/renderer/BodyRenderer.vue";
import Events from "@/components/UserInterfaces/mixins/events";

export default {
    name: "InterfaceRenderer",
    components: { BodyRenderer },
    mixins: [iteratorsCommons, Events],
    props: {
        template: { type: Array, default: null },
        templateData: { type: Object, default: () => ({}) },
        teleportTo: { type: String, default: "" }
    },
    data() {
        return {
            chkTest: true,
            unwatchOnChange: null,
            skipLiveUpdate: true,
            timerStarted: false,
            pendingScripts: false,
            jsonSettings: {
                deep: 3,
                showLength: true,
                showLine: true,
                itemHeight: 17
            }
        };
    },
    computed: {
        ...mapState("components", ["elementState", "activeComponent", "selectPath", "bodyReference"])
    },
    watch: {
        teleportTo(toPath) {
            this.updateGoToPath(toPath);
        }
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            console.log("interface mounted");
        });
    },
    methods: {
        ...mapMutations("components", ["setActiveComponent", "setProperties", "setGoToPath"]),
        updateActiveComponent(event) {
            const el = event.target;

            if (el.classList.contains("body__render")) {
                this.setActiveComponent(null);
            }
        },
        updateGoToPath(toPath) {
            const path = {};

            if (toPath) {
                const teleportList = toPath.split(",");
                const isNumber = (string = "") => /^[0-9]*$/g.test(string);
                const canAddToParentList = (props) => props.__component === "ctrl-slot" || this.components[props.__component].slots;
                let lastEntry, lastPath;

                const getParentList = (from, cbParentTest, untilParent = "") => {
                    const parentList = [];
                    let props = this.properties[from];

                    while (props.parent && props.parent !== untilParent) {
                        if (cbParentTest(this.properties[props.parent])) {
                            parentList.push(props.parent);
                        }
                        props = this.properties[props.parent];
                    }

                    return parentList.reverse();
                };

                const extendedPath = teleportList.map(pathEntry => {
                    if (isNumber(pathEntry)) {
                        return parseInt(pathEntry, 10);
                    }

                    if (this.components[this.properties[pathEntry].__component].acceptNodes) {
                        lastEntry = pathEntry;
                    }

                    return [...getParentList(pathEntry, canAddToParentList, lastEntry), pathEntry];
                }).flat();

                const lastIndex = extendedPath.length - 1;
                lastEntry = "";
                lastPath = "";
                extendedPath.forEach((pathEntry, index) => {
                    if (isNumber(pathEntry) || this.properties[pathEntry].__component === "ctrl-slot") {
                        path[lastEntry].goTo = pathEntry;
                    } else {
                        const entryData = { last: index === lastIndex };
                        const pathIndex = teleportList.indexOf(pathEntry);

                        if (pathIndex !== -1) {
                            lastPath = teleportList.slice(0, pathIndex).join(",");
                            entryData.exactPath = lastPath;
                        } else {
                            entryData.exactPath = lastPath;
                        }

                        path[pathEntry] = entryData;
                        lastEntry = pathEntry;
                    }
                });
            }

            console.log(path);
            this.setGoToPath(path);
        },
        getNextDiffs() {
            const componentDiffs = { diffs: [], guid: null };

            while (!componentDiffs.diffs.length && orderedComponentQueue.length) {
                const checkedComponent = orderedComponentQueue.shift();
                const lhs = getData(oldDataState, checkedComponent);
                const rhs = getData(currentDataState, checkedComponent);

                const diffs = getRecursiveDiff(lhs, rhs, { oldValues: true });
                if (diffs.length) {
                    componentDiffs.guid = checkedComponent;
                    componentDiffs.diffs = diffs;

                    diffs.sort(({ path: pathA }, { path: pathB }) => this.sortEntryPaths(pathA, pathB));

                    showDebug && console.groupCollapsed("%cgetNextDiffs: Found %s diff(s) on %s", "color: orange;", diffs.length, checkedComponent);
                    showDebug && diffs.forEach((diff) => console.log(diff));
                    showDebug && console.groupEnd();
                }
            }

            return componentDiffs;
        },
        updateLive() {
            this.clearPendingWorkInterval();
            this.updateLiveData();
            this.stopPerfTimer();
        },
        checkChanges() {
            if (this.pendingScripts.length) {
                this.consumePendingScript();
            } else {
                const { diffs, guid } = this.getNextDiffs();

                if (guid) {
                    this.currentRunningId = guid;
                    this.pendingScripts = this.checkDiffEvents(diffs);
                    this.consumePendingScript();
                } else {
                    console.log("update live");
                    this.updateLive();
                }
            }
        },
        checkDiffEvents(diffs) {
            const events = [];

            for (let loop = 0, max = diffs.length; loop < max; loop++) {
                const diff = diffs[loop];
                const { path, op } = diff;
                const valueIndex = path.indexOf("value");

                if (valueIndex === -1) {
                    // is add
                    events.push({ type: "add", guid: this.currentRunningId, oldValue: {}, newValue: {}, diff: [diff] });
                } else {
                    const { config, guid } = this.getDetails(this.currentRunningId);
                    if (config.namespace) {
                        const eventsPath = path.slice(0, valueIndex);
                        const newEvents = this.eventsFromChangePath(eventsPath, events);
                        const last = newEvents.pop();

                        last.diff = [diff];
                        events.push(...newEvents, last);
                    } else {
                        events.push({ type: "change", guid, oldValue: {}, newValue: {}, diff: [diff] });
                    }
                }
            }

            return events;
        },
        eventsFromChangePath(path, accEvents) {
            const triggers = [this.getCode(path.at(-1))];
            const events = [];
            const accPath = [];

            for (let loop = 0, max = path.length - 1; loop <= max; loop++) {
                const item = path[loop];
                const isIndex = typeof item === "number";
                const guid = isIndex ? path[loop - 1] : item;

                accPath.push(item);
                if (!this.trackedComponents[guid]) { continue; }

                let type, index;

                if (isIndex) {
                    type = "ns_child_change";
                    index = item;
                } else {
                    type = loop === max ? "ns_change" : "ns_root_change";
                    index = loop === 0 ? null : path[loop - 1];
                }

                const rawPath = accPath.join("_");
                if (accEvents.find((e) => e.type === type && e.rawPath === rawPath)) { continue; }

                const parent = index === null ? null : path.slice(0, loop);
                events.push({
                    type, index, guid, rawPath, triggers, parent,
                    path: path.slice(0, loop + 1)
                });
            }

            return events;
        },
        clearPendingWorkInterval() {
            clearInterval(this.pendingWork);
            this.pendingWork = null;
        },
        updateLiveData() {
            const cleanedLiveState = this.cloneAndClean(this.liveData);
            const diffs = getRecursiveDiff(cleanedLiveState, oldDataState, { checkEquality: false });

            if (diffs.length) {
                this.skipLiveUpdate = true;
                this.updateWithDiffs(this.liveData, diffs);
            }
        }
    }
};
